export default {
  title: 'WAP reports',
  tableHeaderActionTooltip: 'Create new WAP report',
  dialog: {
    title: {
      generateReport: 'Generate WAP report',
      deleteReport: 'Delete WAP report',
      cancelReport: 'Cancel WAP report',
      regenerateReport: 'Regenerate WAP report',
      retryReport: 'Retry WAP report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate WAP report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Report name',
    placeholder: 'Enter WAP report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'Enter starting date'
    },
    endDate: {
      label: 'End date',
      placeholder: 'Enter end date'
    },
    appIds: {
      label: 'App Ids',
      placeholder: 'Select app Ids'
    },
    operationIds: {
      label: 'Session Ids',
      placeholder: 'Select session Ids'
    },
    phoneNumbers: {
      label: 'Phone number(s)',
      placeholder: 'Select phone number(s)'
    },
    operators: {
      label: 'Operator',
      placeholder: 'Select operators'
    },
    sessionTypes: {
      label: 'Session type(s)',
      placeholder: 'Select session types'
    },
    sessionTags: {
      label: 'Session tag(s)',
      placeholder: 'Select session tags',
      helperText:
        // eslint-disable-next-line max-len
        "By pressing 'Enter' you can provide multiple values. If you want to filter rows without a session tag, add the tag 'NO_TAG'"
    },
    sessionCloseReasons: {
      label: 'Session close reason(s)',
      placeholder: 'Select session close reasons'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    appIds: {
      label: 'App Id(s)'
    },
    operationIds: {
      label: 'Session Id(s)'
    },
    phoneNumbers: {
      label: 'Phone number(s)'
    },
    operators: {
      label: 'Operator(s)'
    },
    sessionTypes: {
      label: 'Session type(s)'
    },
    sessionTags: {
      label: 'Session tag(s)',
      helperText:
        // eslint-disable-next-line max-len
        "By pressing 'Enter' you can provide multiple values. If you want to filter sessions without tag, add tag 'NO_TAG'\""
    },
    sessionCloseReasons: {
      label: 'Session close reason(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
